<template>
  <div class="marginLeft upper-parent">
    <div class='same-line itemsContainer inline-block upper-parent-child1'>
      <div class='offer-name'>
        <div v-if="gettersSelectedOffer && gettersSelectedOffer.name">
          {{ this.gettersSelectedOffer.name }}
        </div>
        <div v-if="duplicatedItemName && duplicatedItemName.name" class="item-text">
          {{ duplicatedItemName.name }}
        </div>
      </div>
      <searchable-dropdown
        id='waterfall1'
        :list='itemArrays'
        v-model='selectedItem'
        :selectedItem="selectedItem ? this.selectedItem.name : ''">
      </searchable-dropdown>
    </div>
    <div
      class="inline-block upper-parent-child2"
      :style="{'width': '80%'}">
      <div class="chart-container">
        <vue-chart
          chart-type='CandlestickChart'
          :columns='columns'
          :rows='rows'
          :version="45"
          :options='options'>
        </vue-chart>
      </div>
    </div>
  </div>
</template>
<script>
// import { mockChartData } from './mock'
// import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import * as NameSpace from '../../store/NameSpace'
import SearchableDropdown from 'src/components/shared/SearchableDropDown'
// import { CLEAR_FILTER } from 'src/constants/Constants'
import { cloneDeep } from 'lodash'

export default {
  data () {
    return {
      itemArrays: [],
      selectedItem: null,
      rows: null,
      chartEvents: {
        ready: this.fillColor
      },
      toolTipStyle: 'style="width: 180px; padding: 5px; font-size: 1.5rem; font-weight: bold"',
      duplicatedItemName: null,
      homeRouterPath: '/pending-offers'
    }
  },
  created () {
    this.itemArrays = this.offerItems
    this.selectedItem = this.itemArrays[0]
    this.selectedItem = this.itemArrays[0]
    if (!this.selectedItem) {
      this.$router.push(this.homeRouterPath)
    }
    this.duplicatedItemName = cloneDeep(this.selectedItem)
  },
  watch: {
    'gettersWaterfallChartData.data' () {
      this.processData()
    },
    'gettersWaterfallChartData.error' () {
      if (this.gettersWaterfallChartData.error) {
        let msg = this.gettersWaterfallChartData.error ? this.gettersWaterfallChartData.error : 'Opps got unknown error'
        this.pop({
          header: 'ERROR!!',
          message: msg + ', please click back button.',
          type: 'ERROR'
        })
      }
    },
    selectedItem () {
      if (this.selectedItem.id) {
        this.duplicatedItemName = cloneDeep(this.selectedItem)
        const {storeLevel, period} = this.gettersAggInputData
        this.fetchWaterfallChartData({ itemId: this.selectedItem.id, storeLevel: storeLevel.id, period: period.id })
      }
    }
  },
  computed: {
    ...mapGetters({
      gettersOfferDetails: NameSpace.GET_OFFER_ITEMS,
      gettersAggInputData: NameSpace.GET_AGG_INPUT_FILTER_DATA,
      gettersSelectedOffer: NameSpace.GET_SELECTED_OFFER_NAME,
      gettersWaterfallChartData: NameSpace.GET_WATERFALL_DATA
    }),
    offerItems () {
      let parentArray = this.gettersOfferDetails.detailedData
      return parentArray.map((arr) => {
        return {name: arr[0], id: arr.itemId}
      })
    },
    graphData () {
      return this.gettersWaterfallChartData.data.graphData
    },
    labels () {
      return this.gettersWaterfallChartData.data.labels
    },
    colors () {
      return this.gettersWaterfallChartData.data.colors
    },
    columns () {
      return [
        {
          'type': 'string'
        },
        {
          'type': 'number'
        },
        {
          'type': 'number'
        },
        {
          'type': 'number'
        },
        {
          'type': 'number'
        },
        {
          type: 'string',
          role: 'tooltip',
          'p': {
            'html': true
          }
        }
      ]
    },
    options () {
      return {
        tooltip: {isHtml: true},
        chartArea: {
          width: '80%'
        },
        legend: 'none',
        animation: {
          duration: 600,
          easing: 'out',
          startup: true
        },
        height: 450,
        width: 1000,
        bar: {
          groupWidth: '30%'
        },
        vAxis: {
          title: 'Dollar(s) $'
        },
        title: this.gettersSelectedOffer.name,
        candlestick: {
          fallingColor: { strokeWidth: 0, fill: '#a52714' }, // red
          risingColor: { strokeWidth: 0, fill: '#0f9d58' }   // green
        }
      }
    }
  },
  methods: {
    ...mapActions({
      fetchWaterfallChartData: NameSpace.FETCH_WATERFALL_DATA,
      pop: NameSpace.SET_MODAL_CONFIG_ACTION
    }),
    processData () {
      this.setRows()
    },
    setRows () {
      let graphData = this.graphData
      // let baseLine = graphData.baseLineMargin
      // let salesLift = graphData.salesLift
      // let halo = graphData.halo
      // let affinity = graphData.affinity
      // let cannibalization = graphData.cannibalization
      // let pullForward = graphData.pullForward
      // let total = graphData.total
      if (graphData) {
        let result = Object.keys(graphData).map((data) => {
          let label = this.labels[data]
          let zeroth = graphData[data][0]
          let oneth = graphData[data][1]
          let tooltip = ''
          if (data === 'baseLineMargin' || data === 'total') {
            oneth = Math.round(oneth * 100) / 100
            tooltip = tooltip.concat(`<div ${this.toolTipStyle}>${label} : ${oneth}</div>`)
          } else {
            let delta = oneth - zeroth
            delta = Math.round(delta * 100) / 100
            tooltip = tooltip.concat(`<div ${this.toolTipStyle}>${label} : ${delta}</div>`)
          }
          return [label, zeroth, zeroth, oneth, oneth, tooltip]
        })
        this.rows = result
      } else {
        this.rows = []
      }

      // let bar = document.querySelectorAll('rect[fill="#0f9d58"]')
      // bar[0].setAttribute('fill', this.colors['baseLineColor'])
      // bar[bar.length - 1].setAttribute('fill', this.colors['totalColor'])
    }
  },
  components: {
    SearchableDropdown
  }
}
</script>
<style scoped>
  .upper-parent {
    flex-direction: row;
    display: flex;
    flex: 1
  }

  .upper-parent-child1 {
    display: flex;
    flex: 2
  }

  .upper-parent-child2 {
    display: flex;
    flex: 8
  }
  .marginLeft {
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .chart-container {
    width: 100%;
    height: 100%;
  }
  .same-line {
    vertical-align: top;
    display: inline-block;
  }
  .itemsContainer {
    background-color: '#f1f1f1';
  }
  .offer-name {
    text-align: center;
    font-size: 1.4rem;
    padding: 1rem;
    background: #f3f3f3;
    color: #4d4d4d;
  }
</style>



// WEBPACK FOOTER //
// Waterfall.vue?15ee8dac